import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { c as BusinessFormClickActions } from './business-form-types.js';
import { B as Button } from './button.js';

const PaymentProvisioningFormButtons = /*@__PURE__*/ proxyCustomElement(class PaymentProvisioningFormButtons extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.currentStep = undefined;
        this.totalSteps = undefined;
        this.formLoading = undefined;
        this.formDisabled = undefined;
        this.previousStepButtonOnClick = undefined;
        this.nextStepButtonOnClick = undefined;
    }
    get showPreviousStepButton() {
        return this.currentStep > 0;
    }
    get showNextStepButton() {
        return this.currentStep < this.totalSteps;
    }
    get showSubmitButton() {
        return this.currentStep === this.totalSteps;
    }
    render() {
        return (h("div", { key: '3df3796f2bb35819373564c0002e35d14c85e360', class: 'd-flex gap-2' }, h(Button, { key: '3f8fd4e288b2eed6776c77b44dda816e8a0580cd', variant: "secondary", type: "button", onClick: () => this.previousStepButtonOnClick(), disabled: this.formDisabled, hidden: !this.showPreviousStepButton }, "Previous"), h(Button, { key: '83c7d2405d6e4f88f721a95250aa847a6999a211', variant: "primary", type: "button", onClick: (e) => this.nextStepButtonOnClick(e, BusinessFormClickActions.nextStep), disabled: this.formDisabled, isLoading: this.formLoading, hidden: !this.showNextStepButton }, "Next"), h(Button, { key: 'd87bcdc9bea52b11307e31bd1d99636be05d7156', variant: "primary", type: "submit", onClick: (e) => this.nextStepButtonOnClick(e, BusinessFormClickActions.submit), disabled: this.formDisabled, isLoading: this.formLoading, hidden: !this.showSubmitButton }, "Submit")));
    }
}, [0, "justifi-payment-provisioning-form-buttons", {
        "currentStep": [2, "current-step"],
        "totalSteps": [2, "total-steps"],
        "formLoading": [4, "form-loading"],
        "formDisabled": [4, "form-disabled"],
        "previousStepButtonOnClick": [16],
        "nextStepButtonOnClick": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-payment-provisioning-form-buttons"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-payment-provisioning-form-buttons":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PaymentProvisioningFormButtons);
            }
            break;
    } });
}
defineCustomElement();

export { PaymentProvisioningFormButtons as P, defineCustomElement as d };
